<template>
  <div class="card">
    <div class="card-body" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <form @submit="submit" class="add-edit-form product-form">
              <div class="row">
                <div class="col-lg-6">
                  <label for>
                    <span>Youtube Banner Image</span>
                    <section class="form-control replace" :class="{'d-none': !isObject(youtubeBanner.image)}">
                      <input type="button" class="replace-btn" data-id="image" value="Replace File">
                      <span>{{youtubeBanner.image}}</span>
                    </section>
                    <input :class="{'d-none': isObject(youtubeBanner.image)}" @change="onFileChange($event, 'image')" type="file" id="image" class="form-control" />
                  </label>
                  <label for="" class="checkbox-icon">
                    <span class="text-left">Homepage Banner:</span>
                    <label class="checkbox-container">
                      <input v-model="youtubeBanner.is_homepage_banner" type="checkbox">
                      <span class="checkmark"></span>
                    </label>
                  </label>
                </div>
                <div class="col-lg-6">
                  <div class="thumbnail-display"></div>
                </div>
              </div>
              <div class="col-lg-12 d-flex justify-content-center mt-3">
                <button type="submit" :disabled="this.$store.getters.apiStatus == 'loading'" class="btn btn-success">
                  <div v-if="this.$store.getters.apiStatus != 'loading'">{{toEdit ? 'Update' : 'Save'}}</div>
                  <div v-else class="loader"><Loader></Loader></div>
                </button>
              </div>
            </form>
          </div>
          <div class="col-lg-6"></div>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import YoutubeBanner from '@/models/YoutubeBanner'
export default{
  name: 'YoutubeBannerForm',
  data () {
    return {
      youtubeBanner: new YoutubeBanner()
    }
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    }
  },
  mounted () {
    if (this.toEdit) {
      this.fetchYoutubeBanner()
    }
    $('.thumbnail-display').click(function () {
      $('#thumbnail').click()
    })

    $(document).on('change', '#image', function () {
      if (event.target.files.length) { $('.thumbnail-display').css('background-image', 'url(' + window.URL.createObjectURL(event.target.files[0]) + ')') } else { $('.thumbnail-display').css('background-image', 'none') }
    })

    $('.card').on('click', '.replace-btn', function () {
      var id = $(this).attr('data-id')
      $('#' + id).click()
    })
  },
  methods: {
    fetchYoutubeBanner () {
      this.$store.dispatch('fetchYoutubeBanner', this.$route.params.id)
        .then((result) => {
          this.youtubeBanner = new YoutubeBanner(result.data.youtube_banner)
          $('.thumbnail-display').css('background-image', 'url("' + this.youtubeBanner.imageUrl + '")')
        })
        .catch((err) => this.$helper.catchHandler(err))
      return null
    },
    submit (event) {
      event.preventDefault()
      var youtubeBanner = this.youtubeBanner.getFormData()
      var functionName = 'createYoutubeBanner'
      var successText = 'created'
      if (this.toEdit) { functionName = 'editYoutubeBanner'; successText = 'edited' }
      this.$store.dispatch(functionName, youtubeBanner)
        .then(() => {
          this.$router.push('/youtube-banners')
          this.$toast.success('Youtube Banner ' + successText + ' successfully')
        })
        .catch((err) => {
          console.log(err.response)
          this.$toast.error(err.response.data.message || 'An unkown error occured please contact suppport')
        })
    },
    onFileChange (e, index) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.youtubeBanner[index] = null
        index = null
      } else {
        if (files[0].size / 1000000 > 2) {
          e.preventDefault()
          e.stopPropagation()
          this.youtubeBanner[index] = ''
          index = null
          $('.thumbnail-display').css('background-image', 'none')
          this.$toast.error('File size should be less than 2mb')
          return
        }
        this.youtubeBanner[index] = files[0]
      }
    },
    isObject (val) {
      if (this.toEdit && !(val === 'null' || val === '')) { return true }
      return (typeof val === 'object')
    }
  }
}
</script>

<style scoped>
@media only screen and (min-width: 767px) {
  .cat-div {
    width: 100% !important;
  }
}
.thumbnail-display {
  background-size: contain !important;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/YoutubeBannerForm.vue